"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { RequestCompanyType, RequestTarget, TransferType } from "@/types/busrequest";
import { PropsWithModalClose } from "@/types/props";
import { useTranslation } from "@/app/i18n/client";
import { BusrequestFormSchema, calcCompanyTypeLabel } from "@/components/Home/HomeV2Content/busrequest-helper";
import { api } from "@/utils/trpc/react";
import { Button } from "@/components/ui/button";
import { useDateTimeFormatter } from "@/utils/hooks/use-formatter";
type Props = {
  request: BusrequestFormSchema | null;
};
export default function SinglerequestCheckInputModalContent(t0) {
  const $ = _c(134);
  const {
    request,
    closeModal
  } = t0;
  const {
    t
  } = useTranslation();
  const t1 = request?.requestTarget === "individual";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      enabled: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const companies = api.company.GetRegisteredCompanies.useQuery(undefined, t2);
  const formatDate = useDateTimeFormatter();
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] !== companies || $[3] !== formatDate || $[4] !== request || $[5] !== t) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const selectedCompanyNames = request?.selectedCompanies.map(id => companies.data?.find(c => c.id === id)?.publicData.companyName).filter(Boolean);
      if (!request) {
        t8 = null;
        break bb0;
      }
      t6 = "max-h-[45vh] overflow-y-scroll text-offWhite";
      const t9 = request.transferType ?? "TRANSFERTWOWAY";
      let t10;
      if ($[12] !== t9) {
        t10 = t9.toUpperCase();
        $[12] = t9;
        $[13] = t10;
      } else {
        t10 = $[13];
      }
      const t11 = t(`MANAGEMENT.ADD.${t10}` as `MANAGEMENT.ADD.${Uppercase<TransferType>}`);
      let t12;
      if ($[14] !== t11) {
        t12 = <div className="md:col-span-2 lg:col-span-3">{t11}</div>;
        $[14] = t11;
        $[15] = t12;
      } else {
        t12 = $[15];
      }
      const t13 = t("MAIN.HOMEV2.BUSREQUEST.FROM");
      let t14;
      if ($[16] !== t13) {
        t14 = <b>{t13}</b>;
        $[16] = t13;
        $[17] = t14;
      } else {
        t14 = $[17];
      }
      let t15;
      if ($[18] !== request.from.address || $[19] !== t14) {
        t15 = <div>{t14}: {request.from.address}</div>;
        $[18] = request.from.address;
        $[19] = t14;
        $[20] = t15;
      } else {
        t15 = $[20];
      }
      const t16 = t("MAIN.HOMEV2.BUSREQUEST.FROM_DATE");
      let t17;
      if ($[21] !== t16) {
        t17 = <b>{t16}</b>;
        $[21] = t16;
        $[22] = t17;
      } else {
        t17 = $[22];
      }
      let t18;
      if ($[23] !== formatDate || $[24] !== request.outwardDate) {
        t18 = formatDate(request.outwardDate);
        $[23] = formatDate;
        $[24] = request.outwardDate;
        $[25] = t18;
      } else {
        t18 = $[25];
      }
      let t19;
      if ($[26] !== t17 || $[27] !== t18) {
        t19 = <div>{t17}:{" "}{t18}</div>;
        $[26] = t17;
        $[27] = t18;
        $[28] = t19;
      } else {
        t19 = $[28];
      }
      let t20;
      if ($[29] !== t15 || $[30] !== t19) {
        t20 = <div>{t15}{t19}</div>;
        $[29] = t15;
        $[30] = t19;
        $[31] = t20;
      } else {
        t20 = $[31];
      }
      const t21 = t("MAIN.HOMEV2.BUSREQUEST.TO");
      let t22;
      if ($[32] !== t21) {
        t22 = <b>{t21}</b>;
        $[32] = t21;
        $[33] = t22;
      } else {
        t22 = $[33];
      }
      let t23;
      if ($[34] !== request.to.address || $[35] !== t22) {
        t23 = <div>{t22}: {request.to.address}</div>;
        $[34] = request.to.address;
        $[35] = t22;
        $[36] = t23;
      } else {
        t23 = $[36];
      }
      let t24;
      if ($[37] !== formatDate || $[38] !== request.returnDate || $[39] !== request.transferType || $[40] !== t) {
        t24 = request.transferType === "transfertwoway" || request.transferType === "transfertour" ? <div><b>{t("MAIN.HOMEV2.BUSREQUEST.TO_DATE")}</b>:{" "}{formatDate(request.returnDate)}</div> : null;
        $[37] = formatDate;
        $[38] = request.returnDate;
        $[39] = request.transferType;
        $[40] = t;
        $[41] = t24;
      } else {
        t24 = $[41];
      }
      let t25;
      if ($[42] !== t23 || $[43] !== t24) {
        t25 = <div><div>{t23}{t24}</div></div>;
        $[42] = t23;
        $[43] = t24;
        $[44] = t25;
      } else {
        t25 = $[44];
      }
      const t26 = t("MANAGEMENT.ADD.PASSENGERS.TEXT");
      let t27;
      if ($[45] !== t26) {
        t27 = <b>{t26}</b>;
        $[45] = t26;
        $[46] = t27;
      } else {
        t27 = $[46];
      }
      let t28;
      if ($[47] !== request.passengers || $[48] !== t27) {
        t28 = <div>{t27}: {request.passengers}</div>;
        $[47] = request.passengers;
        $[48] = t27;
        $[49] = t28;
      } else {
        t28 = $[49];
      }
      const t29 = t("MAIN.HOMEV2.BUSREQUEST.DESCR");
      let t30;
      if ($[50] !== t29) {
        t30 = <b>{t29}</b>;
        $[50] = t29;
        $[51] = t30;
      } else {
        t30 = $[51];
      }
      let t31;
      if ($[52] !== request.description || $[53] !== t30) {
        t31 = <div className="md:col-span-2 lg:col-span-3">{t30}: {request.description}</div>;
        $[52] = request.description;
        $[53] = t30;
        $[54] = t31;
      } else {
        t31 = $[54];
      }
      if ($[55] !== t12 || $[56] !== t20 || $[57] !== t25 || $[58] !== t28 || $[59] !== t31) {
        t7 = <div className="mb-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">{t12}{t20}{t25}{t28}{t31}</div>;
        $[55] = t12;
        $[56] = t20;
        $[57] = t25;
        $[58] = t28;
        $[59] = t31;
        $[60] = t7;
      } else {
        t7 = $[60];
      }
      t5 = "mb-4";
      const t32 = t("MAIN.HOMEV2.BUSREQUEST.TARGETTYPE");
      let t33;
      if ($[61] !== t32) {
        t33 = <b>{t32}</b>;
        $[61] = t32;
        $[62] = t33;
      } else {
        t33 = $[62];
      }
      let t34;
      if ($[63] !== request.requestTarget || $[64] !== t) {
        t34 = request.requestTarget ? " " + t(`MANAGEMENT.ADD.${request.requestTarget.toUpperCase()}` as `MANAGEMENT.ADD.${Uppercase<RequestTarget>}`) : "";
        $[63] = request.requestTarget;
        $[64] = t;
        $[65] = t34;
      } else {
        t34 = $[65];
      }
      if ($[66] !== t33 || $[67] !== t34) {
        t3 = <div>{t33}:{t34}</div>;
        $[66] = t33;
        $[67] = t34;
        $[68] = t3;
      } else {
        t3 = $[68];
      }
      t4 = request.requestTarget === "individual" && <div><b>{t("MAIN.HOMEV2.BUSREQUEST.TARGETCOMPANIES") + ":"}</b>{selectedCompanyNames?.join(", ")}</div>;
    }
    $[2] = companies;
    $[3] = formatDate;
    $[4] = request;
    $[5] = t;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[69] !== t3 || $[70] !== t4) {
    t9 = <div>{t3}{t4}</div>;
    $[69] = t3;
    $[70] = t4;
    $[71] = t9;
  } else {
    t9 = $[71];
  }
  let t10;
  if ($[72] !== t5 || $[73] !== t9) {
    t10 = <div className={t5}>{t9}</div>;
    $[72] = t5;
    $[73] = t9;
    $[74] = t10;
  } else {
    t10 = $[74];
  }
  const t11 = t("MAIN.HOMEV2.BUSREQUEST.USER_TYPE");
  let t12;
  if ($[75] !== t11) {
    t12 = <b>{t11}</b>;
    $[75] = t11;
    $[76] = t12;
  } else {
    t12 = $[76];
  }
  let t13;
  if ($[77] !== request.companyType) {
    t13 = request.companyType.toUpperCase();
    $[77] = request.companyType;
    $[78] = t13;
  } else {
    t13 = $[78];
  }
  const t14 = t(`PROVIDER.COMPANYTYPE.${t13}.TEXT` as `PROVIDER.COMPANYTYPE.${RequestCompanyType}.TEXT`);
  let t15;
  if ($[79] !== t12 || $[80] !== t14) {
    t15 = <div>{t12}:{" "}{t14}</div>;
    $[79] = t12;
    $[80] = t14;
    $[81] = t15;
  } else {
    t15 = $[81];
  }
  const t16 = t("MAIN.HOMEV2.BUSREQUEST.SURNAME");
  let t17;
  if ($[82] !== t16) {
    t17 = <b>{t16}</b>;
    $[82] = t16;
    $[83] = t17;
  } else {
    t17 = $[83];
  }
  let t18;
  if ($[84] !== request.firstName || $[85] !== t17) {
    t18 = <div>{t17}: {request.firstName}</div>;
    $[84] = request.firstName;
    $[85] = t17;
    $[86] = t18;
  } else {
    t18 = $[86];
  }
  const t19 = t("MAIN.HOMEV2.BUSREQUEST.NAME");
  let t20;
  if ($[87] !== t19) {
    t20 = <b>{t19}</b>;
    $[87] = t19;
    $[88] = t20;
  } else {
    t20 = $[88];
  }
  let t21;
  if ($[89] !== request.lastName || $[90] !== t20) {
    t21 = <div>{t20}: {request.lastName}</div>;
    $[89] = request.lastName;
    $[90] = t20;
    $[91] = t21;
  } else {
    t21 = $[91];
  }
  let t22;
  if ($[92] !== request.companyName || $[93] !== request.companyType || $[94] !== t) {
    t22 = request.companyType !== "PRIVATE" && <div><b>{calcCompanyTypeLabel(request.companyType, t)}</b>:{" "}{request.companyName}</div>;
    $[92] = request.companyName;
    $[93] = request.companyType;
    $[94] = t;
    $[95] = t22;
  } else {
    t22 = $[95];
  }
  const t23 = t("MAIN.HOMEV2.BUSREQUEST.EMAIL");
  let t24;
  if ($[96] !== t23) {
    t24 = <b>{t23}</b>;
    $[96] = t23;
    $[97] = t24;
  } else {
    t24 = $[97];
  }
  let t25;
  if ($[98] !== request.email || $[99] !== t24) {
    t25 = <div>{t24}: {request.email}</div>;
    $[98] = request.email;
    $[99] = t24;
    $[100] = t25;
  } else {
    t25 = $[100];
  }
  const t26 = t("MAIN.HOMEV2.BUSREQUEST.TEL");
  let t27;
  if ($[101] !== t26) {
    t27 = <b>{t26}</b>;
    $[101] = t26;
    $[102] = t27;
  } else {
    t27 = $[102];
  }
  let t28;
  if ($[103] !== request.phone || $[104] !== t27) {
    t28 = <div>{t27}: {request.phone}</div>;
    $[103] = request.phone;
    $[104] = t27;
    $[105] = t28;
  } else {
    t28 = $[105];
  }
  let t29;
  if ($[106] !== t15 || $[107] !== t18 || $[108] !== t21 || $[109] !== t22 || $[110] !== t25 || $[111] !== t28) {
    t29 = <div className="mb-4">{t15}{t18}{t21}{t22}{t25}{t28}</div>;
    $[106] = t15;
    $[107] = t18;
    $[108] = t21;
    $[109] = t22;
    $[110] = t25;
    $[111] = t28;
    $[112] = t29;
  } else {
    t29 = $[112];
  }
  let t30;
  if ($[113] !== t10 || $[114] !== t29 || $[115] !== t6 || $[116] !== t7) {
    t30 = <div className={t6}>{t7}{t10}{t29}</div>;
    $[113] = t10;
    $[114] = t29;
    $[115] = t6;
    $[116] = t7;
    $[117] = t30;
  } else {
    t30 = $[117];
  }
  let t31;
  if ($[118] !== closeModal) {
    t31 = () => closeModal && closeModal(false);
    $[118] = closeModal;
    $[119] = t31;
  } else {
    t31 = $[119];
  }
  const t32 = t("MAIN.CANCEL.TEXT");
  let t33;
  if ($[120] !== t31 || $[121] !== t32) {
    t33 = <Button variant="cancel" size="lg" className="lg:text-lg" onClick={t31}>{t32}</Button>;
    $[120] = t31;
    $[121] = t32;
    $[122] = t33;
  } else {
    t33 = $[122];
  }
  let t34;
  if ($[123] !== closeModal) {
    t34 = () => closeModal && closeModal(true);
    $[123] = closeModal;
    $[124] = t34;
  } else {
    t34 = $[124];
  }
  const t35 = t("MAIN.HOMEV2.BUSREQUEST.SEND_BUTTON");
  let t36;
  if ($[125] !== t34 || $[126] !== t35) {
    t36 = <Button size="lg" variant="matchbus" className="lg:text-lg" onClick={t34}>{t35}</Button>;
    $[125] = t34;
    $[126] = t35;
    $[127] = t36;
  } else {
    t36 = $[127];
  }
  let t37;
  if ($[128] !== t33 || $[129] !== t36) {
    t37 = <div className="mt-8 flex flex-col justify-center gap-4 xs:flex-row xs:gap-8">{t33}{t36}</div>;
    $[128] = t33;
    $[129] = t36;
    $[130] = t37;
  } else {
    t37 = $[130];
  }
  let t38;
  if ($[131] !== t30 || $[132] !== t37) {
    t38 = <div>{t30}{t37}</div>;
    $[131] = t30;
    $[132] = t37;
    $[133] = t38;
  } else {
    t38 = $[133];
  }
  return t38;
}